<template>
  <sp-alert class="slot-inspector-ehr-warning" type="warning">
    <p class="slot-inspector-ehr-warning__title">{{ warning.title }}</p>
    <p class="slot-inspector-ehr-warning__body">{{ warning.body }}</p>
  </sp-alert>
</template>

<script setup>
defineProps({
  /**
   * The not-in-EHR warning as the server words it: `{ title, body }`.
   */
  warning: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.slot-inspector-ehr-warning {
  // Admin's alerts set their text semi-bold. Here a medium-weight title sits over a regular body.
  --sp-comp-alert-content-font-weight: var(--sp-sys-font-weight-normal);
  --sp-comp-alert-content-line-height: var(--sp-ref-scale-20);

  &__title,
  &__body {
    margin: 0;
  }

  &__title {
    margin-block-end: var(--sp-ref-scale-4);
    font-weight: var(--sp-sys-font-weight-medium);
  }
}
</style>
